import {useEffect, useState} from 'react'

/**
 * Suscribe el componente a una media query del navegador.
 *
 * Se usa para renderizar UNA sola de las dos variantes de un listado (tabla en
 * escritorio, cards en movil) en vez de esconder una con `d-none`: asi no se
 * duplican los ids de los tooltips ni se paga el costo de montar ambas.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState<boolean>(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false
  )

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mediaQueryList = window.matchMedia(query)
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches)

    setMatches(mediaQueryList.matches)
    mediaQueryList.addEventListener('change', onChange)
    return () => mediaQueryList.removeEventListener('change', onChange)
  }, [query])

  return matches
}

/** Breakpoint `md` de Bootstrap: por debajo de 768px se muestran cards. */
export const useIsMobileViewport = () => useMediaQuery('(max-width: 767.98px)')
